import { GetPageMeta, GetPagePayload } from 'types/store/GetPageState';
import { createAsyncReducer } from 'utils/Redux';

import { getPageActions } from '../actions';

export default createAsyncReducer<GetPageMeta, GetPagePayload>(getPageActions);
